import { useContext } from 'react';

import { LayoutContext } from './LayoutContext';

const useLayoutContext = () => {
  const ctx = useContext(LayoutContext);

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!ctx) throw new Error('⚠️ useLayoutContext was called outside of <LayoutContext.Provider>.');

  return ctx;
};

export { useLayoutContext };
